import React from 'react';
import PreserveFormatting from 'components/shared/PreserveFormatting/index';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const EventRegistrationHeader = event => (
  <div className="EventRegistrationHeader">
    <div className="d-f jc-sb ai-fs mb-16">
      <h1 className="ff-ss ws-pr mr-8">{event.name}</h1>
    </div>
    <p className="fz-bigger">
      <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
        <PreserveFormatting>{event.description}</PreserveFormatting>
      </Text>
    </p>
  </div>
);

export default EventRegistrationHeader;
